import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

// navFlow + parent are sensible defaults (matching the homeEnergyOverview sibling);
// confirm with product/UX: navFlow STANDARD vs FOCUS, parent Tab MORE/DASHBOARD/USAGE.
export const homeEnergyAudit_KRAKEN: IMcAppType = {
  name: "homeEnergyAudit_KRAKEN",
  path: "/my/home-energy-audit",
  description: "Origin home energy audit",
  navFlow: NavFlow.STANDARD,
  title: "Home energy audit",
  parent: Tab.MORE,

  conditions: {
    intent: "homeEnergyAudit",
    customerType: CustomerType.kraken,
  },
};
